module.exports = __webpack_public_path__ + "static/inside_video_2s-f2007efcb3ee39bbbf264b25e5b30838.mp4";